/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_Open_LabelInputs */

const en_common_support_open_label = /** @type {(inputs: Common_Support_Open_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact support`)
};

const zh_common_support_open_label = /** @type {(inputs: Common_Support_Open_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系客服`)
};

/**
* | output |
* | --- |
* | "Contact support" |
*
* @param {Common_Support_Open_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_open_label = /** @type {((inputs?: Common_Support_Open_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_Open_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_open_label(inputs)
	return zh_common_support_open_label(inputs)
});
export { common_support_open_label as "common.support.open_label" }